/**
 * npm install --save vuex@3.6.2
 */

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    experiment: undefined,
    actions: undefined,
    ready: undefined,
    sampling: [0, 0]
  },
  mutations: {
    experiment(state, val) {
      state.experiment = val
    },
    sampling(state, val) {
      state.sampling = val
    },
    /**
     * 初始时一次性取当前所有快照（后续靠websocket推送增加）,val是个数组
     */
    shortcuts(state, val) {
      state.shortcuts = val
    },
    /**
     * 控制参数
     */
    actions(state, val) {
      state.actions = val
    },
    prestart(state) {
      state.ready = 1
    },
    unstart(state) {
      state.ready = 0
    },
    start(state) {
      state.ready = 100
    },
    stop(state) {
      state.ready = -1
    }
  },
  getters: {
    experiment(state) {
      return state.experiment
    },
    sampling(state) {
      return state.sampling
    },
    phase(state) {
      const { experiment } = state
      if (!experiment) {
        return 'unknown'
      } else {
        return experiment.complete
          ? 'complete'
          : experiment.start
          ? 'run'
          : 'plan'
      }
    },
    actions(state) {
      return state.actions
    },
    ready(state) {
      return state.ready
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js